<script>
import { vSlidenIn } from '@/utils/vSlidenIn.js';
import { vZoomIn } from '@/utils/vZoomIn.js';

export default {
  name: 'SolutionConsult',
  directives: {
    slidenIn: vSlidenIn,
    zoomIn: vZoomIn,
  },
  data() {
    return {
      sections: [
        {
          title: '一、油气开发工程数智服务',
          subtitle: '围绕油气勘探开发与工程建设全过程，通过数据集成与智能分析，实现油藏研究、工程作业与井场生产智能化管理，提升开发效率与资源利用水平。',
          consultLabel: '油气开发工程数智服务',
          cards: [
            { href: '/intelligentReservoir', title: '智能油藏', image: require('@/assets/anxun1.png'), duration: 600 },
            { href: '/monitorAnxun', title: '智慧钻井', image: require('@/assets/home6.png'), duration: 1000 },
            { href: '/wellbore', title: '智慧井筒', image: require('@/assets/home/wellbore.jpeg'), duration: 1000 },

          ],
        },
        {
          title: '二、油气场站数智服务',
          subtitle: ' 覆盖油气生产运输环节，通过自动化控制、实时监测与生产优化，实现站场运行管理、管网安全监控与炼化生产优化，提升油气生产效率与安全水平。',
          consultLabel: '油气场站数智服务',
          cards: [
            { href: '/station', title: '智慧油气处理场站', image: require('@/assets/home1.png'), duration: 600 },
            { href: '/product', title: '智慧生产与计量场站', image: require('@/assets/home3.png'), duration: 600 },
            { href: '/pipeline', title: '智慧管储', image: require('@/assets/home7.png'), duration: 600 },
            { href: '/refining', title: '智慧净炼化', image: require('@/assets/anxun2.png'), duration: 600 },
            { href: '/control', title: '智能控制系统', image: require('@/assets/home/control.jpeg'), duration: 600 },
          ],
        },
        {
          title: '三、智慧安防服务',
          subtitle: '聚焦油气企业安全管理与运营保障，融合AI视频监控、人员定位与安全预警等多系统联动，构建覆盖安全生产、运营管理及基础设施的综合安全保障体系。',
          consultLabel: '智慧安防服务',
          cards: [
            { href: '/security', title: '智慧安防', image: require('@/assets/home2.png'), duration: 800 },
            // { href: '/smartManagement', title: '智慧管理', image: require('@/assets/anxun3.png'), duration: 1000 },
            // { href: '/basic', title: '基础设施服务', image: require('@/assets/home8.png'), duration: 800 },
          ],
        },
        {
          title: '四、新能源数智服务',
          subtitle: '围绕油气企业能源转型需求，提供智慧新能源数字化解决方案，实现新能源设施高效运行与智能运维，助力企业降本增效与绿色低碳发展。',
          consultLabel: '新能源数智服务',
          cards: [
            // { href: '/digital', title: '油气数智化全场景伴随服务', titleHtml: '油气数智化全场景<br>伴随服务', image: require('@/assets/settingsucesse11.png'), duration: 1000 },
            { href: '/newEnergy', title: '智慧新能源', image: require('@/assets/anxun4.png'), duration: 800 },
            // { href: '/technology', title: '工艺大数据分析', image: require('@/assets/home5.png'), duration: 800 },

          ],
        },
        {
          title: '五、特色AI产品及服务',
          subtitle: '基于对油气业务理解与行业数据积累，为油气田客户提供特色AI产品、定制化开发服务及数据治理服务。',
          consultLabel: '特色AI产品及服务',
          cards: [
            { href: '/oilfieldAI', title: '油气开发AI产品及定制化服务', image: require('@/assets/pro1.jpg'), duration: 800 },
            { href: '/enterpriseAI', title: '企业管理AI产品及定制化服务', image: require('@/assets/knowledgenew1.jpg'), duration: 800 },
            { href: '/company', title: '数据治理服务', image: require('@/assets/zijian3.png'), duration: 800 },

          ],
        },
      ],
    };
  },
  methods: {
    clickConsult(itemName) {
      this.$emit('clickConsult', itemName);
    },
    /** 供父组件滚动定位：返回第 index 个小节的 DOM 元素（0=油气工程，1=场站，2=智慧安防，3=新能源） */
    getSectionEl(index) {
      const ref = this.$refs.sectionRef;
      if (!ref) return null;
      return Array.isArray(ref) ? ref[index] : ref;
    },
  },
};
</script>

<template>
  <div class="solution-consult">
    <div
      v-for="(section, index) in sections"
      :key="index"
      ref="sectionRef"
      :class="['solution-section', { 'solution-section--alt': index % 2 === 1 }]"
    >
      <div class="section-header">
        <div style="display: flex; margin: 0 auto;">
          <div style="display: flex; margin: 0 auto; text-align: center;">
            <div v-sliden-in="{ duration: 600 }" class="title">{{ section.title }}</div>
          </div>
        </div>
        <div v-if="section.cards.length > 1" v-sliden-in="{ duration: 600 }" class="light" style="width: fit-content;">
          {{ section.subtitle }}
          <span class="light2">
            <br />
            如想开展进一步的产品展示和交流，请
            <span class="clickinfo"
              style="color: white; background-color: #282d7d; padding: 5px; border-radius: 9px; font-weight: bolder; font-size: 1.1vw; cursor: pointer"
              @click="clickConsult(section.consultLabel)">
              点击咨询
            </span>
            。
          </span>
        </div>
      </div>

      <!-- 多卡：3 列 grid -->
      <div v-if="section.cards.length > 1" class="pro3"
        style="grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr); display: grid; overflow-y: hidden; grid-column-gap: 1vw; grid-row-gap: 0.5vw;">
        <a v-for="(card, cardIndex) in section.cards" :key="cardIndex" :href="card.href" target="_blank">
          <div v-zoom-in="{ duration: card.duration }" class="grand1" style="position: relative; height: fit-content;">
            <div class="back">
              <div class="photo">
                <img class="image" style="border-radius: 9px" :src="card.image" />
              </div>
            </div>
            <div class="back1">
              <div class="title1" v-html="card.titleHtml || card.title"></div>
              <div class="title2">
                更多&nbsp;<img style="width: 0.6vw; object-fit: contain; border-radius: 9px"
                  src="@/assets/more_btn_icon.png" />
              </div>
            </div>
          </div>
        </a>
      </div>

      <!-- 单卡：左侧文案 + 右侧单卡 -->
      <div v-else class="section-single-card-lr">
        <div class="section-single-left">
          <!-- <div v-sliden-in="{ duration: 600 }" class="title title-left">{{ section.title }}</div> -->
          <div v-sliden-in="{ duration: 600 }" class="light light-left">
            {{ section.subtitle }}
            <span class="light2">
              <br />
              如需相关业务场景服务，请
              <span class="clickinfo"
                style="color: white; background-color: #282d7d; padding: 5px; border-radius: 9px; font-weight: bolder; font-size: 1.1vw; cursor: pointer"
                @click="clickConsult(section.consultLabel)">
                点击咨询
              </span>
              。
            </span>
          </div>
        </div>
        <div class="section-single-right">
          <a :href="section.cards[0].href" target="_blank">
            <div v-zoom-in="{ duration: section.cards[0].duration }" class="grand1 grand1-single"
              style="position: relative; height: fit-content;">
              <div class="back">
                <div class="photo">
                  <img class="image" style="border-radius: 9px" :src="section.cards[0].image" />
                </div>
              </div>
              <div class="back1">
                <div class="title1" v-html="section.cards[0].titleHtml || section.cards[0].title"></div>
                <div class="title2">
                  更多&nbsp;<img style="width: 0.6vw; object-fit: contain; border-radius: 9px"
                    src="@/assets/more_btn_icon.png" />
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.solution-consult {
  z-index: 10;
  width: 100%;
  height: fit-content;
  padding: 0;
  background: #ffffff;
}

.solution-section {
  margin-bottom: 4vh;
  padding: 5vh 8.09763142692085vw 8vh 8.09763142692085vw;
  border-radius: 0;
  background-color: #eeeeee;

  &:last-child {
    margin-bottom: 0;
  }
}

.solution-section--alt {
  background-color: #ffffff;
}

.section-header {
  margin-bottom: 4vw;
}

.title {
  height: 8.23733003708282vh;
  opacity: 1;
  font-size: 2.2vw;
  font-family: Sarial, sans-serif, 'Microsoft Yahei';
  font-weight: 700;
  line-height: 4.23733003708282vh;
}

.light {
  margin: 0 auto 1.5vh auto;
  text-align: justify;
  width: 66vw;
  height: fit-content;
  font-size: 1.2vw;
  font-family: Sarial, sans-serif, 'Microsoft Yahei';
  font-weight: 400;
  color: #2c3e50;
  line-height: 4.94437577255871vh;
}

.light2 {
  margin: 0 auto;
  text-align: justify;
  width: 60.9693818602vw;
  font-size: 1.2vw;
  font-family: Sarial, sans-serif, 'Microsoft Yahei';
  font-weight: 400;
  color: #ff6400;
}

/* 多卡 / 单卡共用的卡片样式 */
.solution-consult .grand1 {
  cursor: pointer;
  width: 100%;
  border-radius: 6px;
  padding: 0.98887515451174vh 0 0 0;
  opacity: 1;
  height: 250px;
  position: relative;

  .back {
    width: 100%;
    height: fit-content;
    background-color: white;
    border: white 2px solid;
  }

  .back1 {
    bottom: 0;
    position: absolute;
    width: 100%;
    color: white;
    height: 30%;
    background: linear-gradient(to top, rgba(27, 30, 118) 0%, rgba(27, 30, 118) 50%, transparent 100%);
    border: white 2px solid;
    border-top: none;
    display: flex;
    border-bottom-left-radius: 9px;
    border-bottom-right-radius: 9px;
    padding: 10px 15px;
    justify-content: space-between;
  }

  .photo {
    overflow: hidden;
    border-radius: 9px;
    border: #dddddd 3px solid;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 1.25;
    width: 100%;
    height: 35vh;
  }

  .title1 {
    opacity: 4;
    text-align: left;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.4vw;
    font-family: Roboto, sans-serif;
    font-weight: bold;
    color: white;
  }

  .title2 {
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 4;
    height: 100%;
    margin: auto 0 0 auto;
    font-size: 1.2vw;
    font-family: Roboto, sans-serif;
    font-weight: 500;
  }
}

/* 多卡：3 列网格 */
.pro3 {
  height: fit-content;
  width: 100%;
  overflow-x: hidden;
}

/* 单卡：左侧文案 + 右侧单卡，两栏布局 */
.section-single-card-lr {
  display: flex;
  align-items: center;
  gap: 3vw;
  width: 100%;

  .section-single-left {
    flex: 0 1 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;

    .title-left {
      text-align: left;
      margin-bottom: 1.5vh;
    }

    .light-left {
      margin: 0;
      width: 100%;
      max-width: none;
    }
  }

  .section-single-right {
    flex: 0 1 50%;
    min-width: 0;

    a {
      display: block;
    }

    .grand1-single {
      max-width: 100%;

      .photo {
        height: 44vh;
      }
    }
  }
}
</style>
